import { formatTwoKTime } from '../utils/twoKTime';
import { Fragment } from 'react';

function formatPct(value) {
  if (value == null || Number.isNaN(Number(value))) return null;
  return `${Number(value).toFixed(1)}%`;
}

function pctColor(value) {
  if (value == null) return 'text-gray-400';
  if (value >= 100) return 'text-green-700';
  if (value >= 90) return 'text-green-600';
  if (value >= 80) return 'text-blue-600';
  if (value >= 70) return 'text-yellow-600';
  return 'text-gray-600';
}

export function PrognosticBadges({ result, className = '' }) {
  if (!result) return null;
  const items = [
    { label: '% 2k Goal', value: formatPct(result.speed_percent), raw: result.speed_percent },
    { label: '% Goal', value: formatPct(result.goal_percent_achieved), raw: result.goal_percent_achieved },
    { label: 'Est 2k', value: formatTwoKTime(result.estimated_2k_seconds) || null, raw: result.estimated_2k_seconds },
    { label: 'Prognostic %', value: formatPct(result.two_k_goal_percent), raw: result.two_k_goal_percent }
  ].filter((item) => item.value);

  if (items.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`}>
      {items.map((item) => (
        <span
          key={item.label}
          className={`inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium ${pctColor(item.raw)}`}
          title={item.label}
        >
          <span className="text-gray-500 font-normal">{item.label}</span>
          {item.value}
        </span>
      ))}
    </div>
  );
}

export function PrognosticTableCells({ result }) {
  const cells = [
    { key: 'speed', value: formatPct(result?.speed_percent), raw: result?.speed_percent },
    { key: 'goal', value: formatPct(result?.goal_percent_achieved), raw: result?.goal_percent_achieved },
    { key: 'est', value: formatTwoKTime(result?.estimated_2k_seconds) || null, raw: result?.estimated_2k_seconds, mono: true },
    { key: 'twoK', value: formatPct(result?.two_k_goal_percent), raw: result?.two_k_goal_percent }
  ];

  return (
    <Fragment>
      {cells.map((cell) => (
        <td key={cell.key} className="px-4 py-2 text-right font-mono text-sm">
          {cell.value ? (
            <span className={cell.mono ? 'text-gray-800' : `font-semibold ${pctColor(cell.raw)}`}>
              {cell.value}
            </span>
          ) : (
            <span className="text-gray-400">-</span>
          )}
        </td>
      ))}
    </Fragment>
  );
}

export const PROGNOSTIC_HEADERS = [
  { key: 'speed', label: '% 2k Goal' },
  { key: 'goal', label: '% Goal' },
  { key: 'est', label: 'Est 2k' },
  { key: 'twoK', label: 'Prognostic %' }
];
